import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.less']
})
export class TagsComponent {
  @Input() tags: string[];
  public current: string;

  constructor() {
    if (!this.tags) {
      this.tags = [];
    }
  }

  focus(): void {
    document.getElementById('tagInput').focus();
  }

  keyUp(event: KeyboardEvent): void {
    if (event.keyCode === 188) {
      this.tags.push(this.current.substr(0, this.current.length - 1));
      this.current = '';
    } else if (event.keyCode === 8 && this.current.length === 0) {
      this.current = this.tags.pop();
    }
  }

  blur(): void {
    if (this.current !== '') {
      this.tags.push(this.current);
      this.current = '';
    }
  }

  remove(tagIndex: number): void {
    this.tags.splice(tagIndex, 1);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tags/tags.component.ts